import { Box, Fab, TextField, useMediaQuery } from "@mui/material";
import React from "react";
import ISearchBardProps from "../../interfaces/ISearchBar";
import { Search, Add } from "@mui/icons-material";
import { colors } from "../../../ui/colors";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { AddCoverage } from "../principals/AddCoverage";

export const SearchBar: React.FC<ISearchBardProps> = ({ value, onChange, placeholder = "Search areas...", onSave, initialData, onCancelEdit }) => {
  return (
    <Box
      sx={{
        position: "relative",
        m: 1,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 1.5,
        // border: "1px solid red"
      }}
    >
      <Search sx={{ position: "absolute", left: "10px", zIndex: 1, color: colors.gray[300] }} />
      <TextField
        type="text"
        size="small"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          width: "100%",
          // padding: "10px 10px 10px 32px",
          borderRadius: "80px",
          // border: "1px solid var(--fx-surface-border, #E2E8F0)",
          outline: "none",

          "& .MuiInputBase-root": {
            borderRadius: "80px",
            paddingLeft: "25px",
          },

          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderColor: "#FFAB40",
            },
          },
        }}
      />

      <BaseModalComponent
        modalKey="Organization-CoverageAreas"
        modalLabel={initialData ? "Edit Coverage Area" : "Add Coverage Area"}
        elementTrigger={
          <Fab
            size="small"
            id="trigger-coverage-modal"
            sx={{
              width: "40px",
              height: "30px",
              backgroundColor: colors.orange.base,
              color: "#fff",
              boxShadow: "none",
              "&:hover": { backgroundColor: "#ea580c", boxShadow: "none" },
            }}
          >
            <Add />
          </Fab>
        }
        defaultSizes={{
          width: { xs: "95%", sm: "800px" },
          height: "700px",
        }}
      >
        <AddCoverage onSave={onSave} initialData={initialData} onCancelEdit={onCancelEdit} />
      </BaseModalComponent>
    </Box>
  );
};

export default SearchBar;
